<template>
  <Authenticated>
    <div class="store-wrapper">
      <CartColumn @loadOrderLineItem="loadOrderLineItem" :checkoutOpen="openCheckout" />
      <div :class="getKiosk ? 'kiosk-main' : 'main'">
        <div v-if="showKioskOrderTypeModal" class="info">
          <h3 v-if="getKioskOrderDetails.orderType == 'dine-in'">Enter order name:</h3>
          <h3 v-else>Enter Table No.:</h3>
          <input
            type="text"
            :placeholder="getKioskOrderDetails.orderType == 'dine-in' ? 'Order Name' : 'Table Number'"
            :v-model="getKioskOrderDetails.orderType == 'dine-in' ? orderName : tableNo" />
          <div class="btns">
            <button @click="switchOrderType">Update</button>
            <button @click="showKioskOrderTypeModal = false">Cancel</button>
          </div>
        </div>

        <div v-if="getKiosk" class="welcome-banner">
          <div class="banner-content">
            <img class="bmu_logo" src="BeamMeUpBagelLogoFinal.png" />
          </div>
          <div class="order-type-choice" v-if="getKioskOrderDetails.orderType == 'takeaway'">
            <button @click="showKioskOrderTypeModal = true">Switch to dine-in</button>
          </div>
          <div class="order-type-choice" v-if="getKioskOrderDetails.orderType == 'dine-in'">
            <button @click="showKioskOrderTypeModal = true">Switch to takeaway</button>
          </div>
        </div>

        <div v-if="categories.length > 1" :class="getKiosk ? 'kiosk-buttons' : 'buttons'">
          <div v-for="(cat, idx) in categories.filter((c) => ((getKiosk && !c.key.posOnly) || !getKiosk ? c : false))" :key="cat.id">
            <div v-if="active_products_in_categories(cat).length > 0" class="catergory-select" @click="catScroll(`${idx}`)">
              <p class="cat-name">{{ cat.key.name }}</p>
            </div>
          </div>
        </div>
        <div v-for="(cat, idx) in categories.filter((c) => ((getKiosk && !c.key.posOnly) || !getKiosk ? c : false))" :key="cat.id">
          <div v-if="active_products_in_categories(cat).length > 0" :id="idx" style="scroll-margin-top: 100px" class="background">
            <h2>{{ cat.key.name }}</h2>
            <span v-if="cat.key.description && cat.key.description !== '<p></p>'" v-html="cat.key.description"></span>
            <ul v-if="!getKiosk" class="table wrapper layout">
              <router-link
                :to="`/store/${isModal}/${cat.id.replace(/^.*:/, '')}/${prod.id.replace(/^.*:/, '')}`"
                class="long-section"
                v-for="prod in active_products_in_categories(cat)"
                :key="prod"
                @click.stop.prevent="productClick(prod.value)">
                <span v-if="prod.value.soldout" class="soldout">Sold Out</span>
                <li :class="prod.value.soldout ? 'soldoutProd long-layout' : 'active long-layout'" :key="prod.value.id">
                  <div v-if="siteSettings.imagesRequired">
                    <div v-if="prod.value.images && prod.value.images.length > 0">
                      <div>
                        <img loading="lazy" v-if="prod.value.images[0]" :alt="prod.value.name" :src="prod.value.images[0]" />
                        <img v-else class="product-image" />
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <h3 class="modifier-name">{{ prod.value.name }}</h3>
                  </div>
                </li>
              </router-link>
            </ul>
            <ul v-if="getKiosk" class="kiosk-table wrapper layout">
              <router-link
                :to="`/store/${isModal}/${cat.id.replace(/^.*:/, '')}/${prod.id.replace(/^.*:/, '')}`"
                class="long-section"
                v-for="prod in active_products_in_categories(cat)"
                :key="prod"
                @click.stop.prevent="productClick(prod.value)">
                <span v-if="prod.value.soldout" class="soldout">Sold Out</span>
                <li :class="prod.value.soldout ? 'soldoutProd kiosk-layout' : 'active kiosk-layout'" :key="prod.value.id">
                  <div class="text-center">
                    <h3 class="modifier-name">{{ prod.value.name }}</h3>
                    <!-- <p>${{ prod.value.price }}</p> -->
                  </div>
                  <div v-if="siteSettings.imagesRequired">
                    <div v-if="prod.value.images && prod.value.images.length > 0">
                      <div>
                        <img loading="lazy" v-if="prod.value.images[0]" :alt="prod.value.name" :src="prod.value.images[0]" />
                        <img v-else class="product-image" />
                      </div>
                    </div>
                  </div>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
        <div v-if="siteSettings.customPrice">
          <div class="background">
            <h2>Custom Priced Product</h2>
            <div class="long-layout" @click.stop.prevent="openKeyPad">
              <h3 class="modidifer-name">ADD</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ItemModal :currentProduct="currentProduct" :open="open" :lineItem="lineItem" @closeItemModal="closeItemModal" ref="itemModal" />
    <KeyPad :keyPad="keyPad" @close="closeKeyPad" @enter="customPrice" />
  </Authenticated>
</template>

<script>
import KeyPad from "@/components/_layouts/KeyPad.vue";
//import { defineAsyncComponent } from 'vue'
import Authenticated from "@/components/_layouts/Authenticated";
//import MiniCart from '@/components/Store/MiniCart.vue'
import ItemModal from "@/components/Store/ItemModal";
import { mapGetters, mapActions } from "vuex";
import CartColumn from "./CartColumn.vue";
//import CheckoutModal from "@/components/Store/CheckoutModal.vue";
// import { ref } from "vue";

//const CheckoutModal = defineAsyncComponent(() => import('@/components/Store/CheckoutModal.vue'));

export default {
  name: "app",
  components: {
    Authenticated,
    ItemModal,
    CartColumn,
    KeyPad,
  },
  emits: ["handleMenu"],
  computed: {
    ...mapGetters({
      currency: "currency",
      categories: "categories",
      siteSettings: "siteSettings",
      localSettings: "localSettings",
      allProducts: "allProducts",
      active_products_in_categories: "active_products_in_categories",
      cartCount: "cartCount",
      user: "user",
      trackedCategories: "trackedCategories",
      getKiosk: "getKiosk",
      getKioskOrderDetails: "getKioskOrderDetails",
      getSatellite: "getSatellite",
      getOsPlatform: "getOsPlatform",
    }),

    isModal() {
      if (this.localSettings[0].use_modals && "use_modals" in this.localSettings[0]) {
        return this.localSettings[0].use_modals ? "modal" : "page";
      } else {
        return "modal";
      }
    },

    kioskIsOnWithNoOrderDetails() {
      if (this.getKiosk && Object.keys(this.getKioskOrderDetails).length === 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      openCheckout: false,
      open: false,
      currentProduct: null,
      showHistory: false,
      showCart: true,
      tableMode: false,
      lineItemHash: null,
      lineItem: null,
      show: false,
      change: 0,
      webCart: false,
      showUserModal: false,
      showUserAccountModal: false,
      keyPad: false,
      urlParams: this.$route.params,
      showKioskOrderTypeModal: false,
      orderName: "",
      tableNo: "",
    };
  },

  created() {
    window.addEventListener("resize", this.screenChange);
  },
  async mounted() {
    this.$store.commit("currPage", "store");
    this.screenChange();
    if (this.portrait) {
      window.addEventListener("scroll", this.onScroll);
    } else {
      if (!this.getKiosk) {
        document.querySelector(".main").addEventListener("scroll", this.onScroll);
      } else {
        document.querySelector(".kiosk-main").addEventListener("scroll", this.onScroll);
      }
    }

    if (Object.keys(this.$route.params).length > 0 && Object.keys(this.allProducts).length > 0) {
      this.checkParams();
    }
  },
  unmounted() {
    window.removeEventListener("resize", this.screenChange);
    if (this.portrait) {
      window.removeEventListener("scroll", this.onScroll);
    }
  },
  methods: {
    ...mapActions([]),

    switchOrderType() {
      let updatedDetails = { ...this.getKioskOrderDetails };
      if (this.getKioskOrderDetails.orderType == "takeaway") {
        updatedDetails.orderType = "dine-in";
        updatedDetails.orderName = this.orderName;
        delete updatedDetails.tableNo;
      } else if (this.getKioskOrderDetails.orderType == "dine-in") {
        updatedDetails.orderType = "takeaway";
        updatedDetails.tableNo = this.tableNo;
        delete updatedDetails.orderName;
      }
      this.$store.dispatch("setKioskDetails", updatedDetails);
      this.showKioskOrderTypeModal = false;
    },

    openKeyPad() {
      this.keyPad = true;
    },

    closeKeyPad() {
      this.keyPad = false;
    },

    customPrice(amount) {
      let custProd = {
        id: "product:custom" + amount,
        modifiers: {},
        price: parseFloat(amount),
        category: "unknown",
      };
      this.$refs.itemModal.addToCartWrapper(custProd);
    },

    onScroll() {
      let position = null;
      let buttons = document.querySelector(".main .buttons");
      let main = this.getKiosk ? document.querySelector(".kiosk-main") : document.querySelector(".main");

      if (this.portrait) {
        position = window.pageYOffset / (main.scrollHeight - window.innerHeight);
      } else {
        position = main.scrollTop / (main.scrollHeight - buttons.clientHeight - main.clientHeight);
      }
      let scroll = position * (buttons.scrollWidth - buttons.clientWidth);
      buttons.scrollTo({ top: 0, left: scroll, behavior: "instant" });
    },
    screenChange() {
      let media = matchMedia("(orientation: portrait)");
      if (media.matches) {
        this.portrait = true;
      } else {
        this.portrait = false;
        this.showCart = true;
      }
      if (this.portrait) {
        this.showCart = false;
      }
    },
    topScroll() {
      let media = matchMedia("(orientation: portrait)");
      if (media.matches) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (window.screenTop < window.innerHeight) {
          this.webCart = !this.webCart;
        } else {
          this.webCart = true;
        }
      } else {
        this.webCart = !this.webCart;
      }
    },
    catScroll(pos) {
      const cat = document.getElementById(pos);
      if (cat !== null) {
        cat.scrollIntoView({
          behavior: this.getKiosk ? "smooth" : "instant",
          block: "start",
          inline: "nearest",
        });
      }
    },
    closeItemModal() {
      this.lineItem = null;
      this.open = false;
      this.$router.push({ path: "/store" });
    },
    loadOrderLineItem(lineItem) {
      var product = this.allProducts.find((product) => product.id === lineItem.id);
      //cannot read properties of undefined reading value
      this.currentProduct = product.value;
      this.lineItem = lineItem;
      this.open = true;
    },
    productClick(prod) {
      this.currentProduct = prod;
      this.open = true;
    },
    checkParams() {
      if (this.$route.params.category && this.$route.params.product) {
        let cat = this.categories.find((cat) => cat.id === "category:" + this.$route.params.category);
        let prod = this.active_products_in_categories(cat).find((prod) => prod.value._id === "product:" + this.$route.params.product);
        this.productClick(prod.value);
      }
    },
  },
  watch: {
    open() {
      if (!this.open) {
        this.$router.push({ path: "/store" });
      }
    },
    $route() {
      this.checkParams();
    },
    allProducts() {
      this.checkParams();
    },

    kioskIsOnWithNoOrderDetails() {
      if (this.kioskIsOnWithNoOrderDetails) {
        this.$router.push({ path: "/startOrder" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.store-wrapper {
  display: flex;
  flex-direction: row-reverse;
  height: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;

  .info {
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 0.5rem;
    position: absolute;
    top: 0;
    right: 0;
    background-color: var(--primary-colour);
    box-shadow: var(--box-shadow);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h3 {
      color: var(--action-colour);
      margin: 0.25rem;
    }
    input {
      border-radius: 0.5rem;
      padding: 0.5rem;
      border: none;
      box-shadow: var(--box-shadow);
    }
    .btns {
      button {
        padding: 0.25rem 1rem;
        border: none;
        border-radius: 0.5rem;
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
        box-shadow: var(--box-shadow);
        cursor: pointer;
        &:nth-child(2) {
          background-color: var(--warning-colour);
        }
      }
    }
  }

  .side-scroll {
    overflow: auto;
    white-space: nowrap;
    scroll-snap-type: x mandatory;
  }

  .main {
    height: 100vh;
    overflow-y: scroll;
    width: 90vw;
  }

  .kiosk-main {
    height: 100vh;
    overflow-y: scroll;
    width: 100vw;
  }

  .welcome-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.5rem 1rem;
    padding: 1rem;

    .bmu_logo {
        background-color: white;
        border-radius: 50%;
    }

    .order-type-choice {
      display: flex;
      flex-direction: column;
      align-items: center;
      button {
        background-color: var(--secondary-colour);
        color: var(--action-colour);
        margin: 1rem 0;
      }
    }

    .banner-content {
      .welcome-title {
        font-size: 2.5rem;
        font-weight: bold;
        color: var(--text-colour);
        margin: 0 0 0.5rem 0;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
      .welcome-subtitle {
        font-size: 1.2rem;
        color: var(--text-colour);
        margin: 0;
        font-weight: 300;
      }
    }
  }

  .cart-icon {
    display: none;
  }

  .price {
    float: right;
  }

  .history {
    padding: 0rem 1rem 0rem 1rem;
  }

  h2 {
    font-size: 1.2rem;
    margin: 0px;
    color: var(--text-colour);
  }

  .modifierBox {
    margin: 0.5rem;
    background-color: var(--primary-colour);
    color: var(--text-colour);
    overflow: hidden;
  }

  .soldout {
    font-weight: bold;
    font-size: 1rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--text-colour);
    position: absolute;
    border-radius: 0.25rem;
    padding: 0.4rem 0.8rem;
    margin: 0;
    background: var(--warning-colour);
    overflow: hidden;
    z-index: 1;
    text-align: center;
  }

  .soldoutProd {
    opacity: 0.5;

    &:hover {
      background-color: var(--secondary-colour) !important;
      cursor: default !important;
    }
  }

  .product-image {
    display: block;
    border: 0.1rem solid var(--primary-colour);
    border-radius: 0.25rem;
  }

  .text-center {
    width: 100%;
    overflow-x: hidden;
    white-space: nowrap;

    .modifier-name {
      text-align: center;
      margin: 0;
      font-size: small;
      padding-top: 0.5rem;
    }
    .caption {
      font-size: 0.8rem;
      padding-bottom: 0;
      p {
        margin: 0;
      }
    }
  }

  .long-layout {
    margin: 0.5rem;
    padding: 0.5rem;
    min-height: 1rem;
    max-height: 12rem;
    background-color: var(--primary-colour);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    border: 2px;
    text-transform: capitalize;
    cursor: pointer;
    text-decoration: none;
    color: var(--text-colour);
    border-radius: 0.25rem;
    border-style: solid;
    border-color: var(--primary-colour);
    position: relative;

    img {
      height: 6rem;
      border-radius: 0.25rem;
      border: 1px solid var(--secondary-colour);
    }

    &:hover {
      background-color: var(--primary-colour);
      color: var(--text-colour);
      border-color: var(--primary-colour);
    }
  }

  .kiosk-layout {
    margin: 0.5rem;
    width: 10rem;
    height: 10rem;
    cursor: pointer;
    position: relative;
    box-shadow: var(--box-shadow);
    border-radius: 0.5rem;

    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 10rem;
      width: 10rem;
      border-radius: 0.5rem;
      object-fit: cover;
    }
    
    .text-center {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5rem;
      z-index: 2;

      .modifier-name {
        color: var(--text-colour);
        font-size: 0.9rem;
        font-weight: bold;
        margin: 0 0 0.2rem 0;
        text-align: center;
        white-space: normal;
        line-height: 1.1;
      }

      p {
        margin: 0;
        font-size: 0.8rem;
        font-weight: bold;
        color: var(--action-colour);
      }
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 0.5rem;
      pointer-events: none;
      background: linear-gradient(
        180deg,
        color-mix(in srgb, var(--primary-colour) 30%, transparent) 0%,
        color-mix(in srgb, var(--primary-colour) 70%, transparent) 40%,
        var(--primary-colour) 100%
      );
      z-index: 1;
    }
  }

  .kiosk-buttons {
    display: flex;
    justify-content: flex-start;
    margin: 0rem 1rem 0rem 1rem;
    overflow: auto;
    position: sticky;
    top: 0;
    background-color: var(--primary-colour);
    cursor: pointer;
    z-index: 110;

    .catergory-select {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.5rem 0.5rem 0.5rem 0rem;
      height: 3rem;
      padding: 0rem 1rem;
      background-color: var(--secondary-colour);
      border: 1px solid var(--primary-colour);
      box-shadow: var(--box-shadow);
      white-space: nowrap;
      border-radius: 0.35rem;
      .cat-name {
        text-align: center;
        padding: 0 0.2rem;
        color: var(--action-colour);
      }
    }
    :active {
      scale: 0.95;
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-start;
    margin: 0rem 1rem 0rem 1rem;
    overflow: auto;
    position: sticky;
    top: 0;
    background-color: var(--primary-colour);
    cursor: pointer;
    z-index: 110;

    .catergory-select {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.5rem 0.5rem 0.5rem 0rem;
      height: 3rem;
      padding: 0rem 1rem;
      background-color: var(--action-colour);
      white-space: nowrap;

      .cat-name {
        text-align: center;
        padding: 0 0.2rem;
        color: #fff;
      }

      :hover {
        color: #484646;
      }

      color: var(--text-colour);
      border-radius: 0.35rem;
      border-style: solid;
      border-color: var(--primary-colour);
      //&:hover { background-color: var(--hover-colour); color: var(--text-colour); border-color: var(--primary-colour);}
    }
  }

  .drop-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }

  .layout {
    grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
    margin: 0;
    padding: 0;
  }

  .caption {
    text-align: center;
  }

  .table {
    display: flex;
    justify-content: space-between;
  }

  .background {
    background-color: var(--secondary-colour);
    box-shadow: var(--box-shadow);
    padding: 1rem;
    margin: 0.5rem 1rem 1rem 1rem;
    border-radius: 0.5rem;
    //border-width: 3px;
  }

  img {
    width: 6rem;
  }

  .menu-section {
    display: inline-block;
    width: 14rem;
    scroll-snap-align: center;
  }

  .long-section {
    width: 100%;
    position: relative;
    text-decoration: none;
  }
}

@media only screen and (orientation: portrait) {
  .store-wrapper {
    display: block;
    max-width: 100vw;
    overflow: hidden;

    .main {
      height: inherit;
      width: 100vw;
      overflow-y: unset;
    }

    .background {
      margin: 0rem 1rem 1rem 1rem;
    }

    .buttons {
      margin: 0rem 1rem;
      justify-self: flex-start !important;
      overflow-x: scroll;
    }
  }

  .menu-section {
    display: inline-block;
    width: 14rem;
    scroll-snap-align: center;
  }
}

@media only screen and (orientation: landscape) {
  .store-wrapper {
    .cart {
      flex: 1;
    }

    .main {
      flex: 2;
    }
  }
}
</style>
